/**
 * validator
 *
 * @author Shigq
 * @date 2021/11/8 17:25
 */
var validator = require('validator')

/* todo constant */
var LOCATE = 'zh-CN'

/* todo methods */
/**
 * 非零正整数校验
 *
 * @param value
 * @returns {boolean}
 */
function isPositiveNumber(value) {
	var reg = /^[1-9]\d*$|^[+]?(\d+\.\d+)$/;
	return reg.test(value)
}

/**
 * 手机号校验
 *
 * @param value
 * @param locate
 * @returns {*}
 */
function isMobilePhone(value, locate) {
	locate = locate || LOCATE
	return validator.isMobilePhone(value, locate)
}

/**
 * 身份证号校验
 *
 * @param value
 * @param locate
 * @returns {*}
 */
function isEmail(value) {
	return validator.isEmail(value)
}

/**
 * 邮箱校验
 *
 * @param value
 * @returns {*}
 */
function isIdentityCard(value, locate) {
	locate = locate || LOCATE
	return validator.isIdentityCard(value, locate)
}

/**
 * 是否为Swift Code
 *
 * @param value
 * @returns {*}
 */
function isBIC(value) {
	return validator.isBIC(value)
}

/**
 * 是否为IBAN
 *
 * @param value
 * @returns {*}
 */
function isIBAN(value) {
	return validator.isIBAN(value)
}

/**
 * 是否为ABA
 *
 * @param value
 * @returns {*}
 */
function isABA(value) {
	return value && value.length === 9
}

/**
 * 是否为USCC
 *
 * @description Uniform Social Credit Code
 * @param value
 * @returns {*}
 */
function isUSCC(value) {
	return value && value.length === 18
}

function isIP(value) {
	return validator.isIP(value)
}


module.exports = {
	isPositiveNumber,
	isMobilePhone,
	isEmail,
	isIdentityCard,
	isBIC,
	isIBAN,
	isABA,
	isUSCC,
	isIP
}
